
<template>
  <div class="page page-center">
    <div class="container container-tight py-4">
      <div class="text-center mb-4 mt-4">
        <a href="." class="navbar-brand navbar-brand-autodark">
          <img src="/img/logo.png" width="110" height="32" alt="Tabler" class="navbar-brand-image">
        </a>
      </div>
      <div class="card card-md pb-4">
        <div class="card-body">
          <h2 class="h2 text-center mb-4">登录</h2>
          <form action="./" method="get" autocomplete="off" novalidate="">
            <div class="mb-3">
              <label class="form-label">邮箱或者手机号</label>
              <input type="text" class="form-control" placeholder="邮箱或者手机号" v-model="account" autocomplete="off">
            </div>
            <div class="mb-2">
              <label class="form-label">
                密码
              </label>
              <div class="input-group input-group-flat">
                <input type="password" class="form-control" placeholder="密码" v-model="password" autocomplete="off">
              </div>
            </div>
            <div class="form-footer">
              <button type="button" class="btn btn-primary w-100" @click="signinBtn">登录</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { global } from '../global.js'
export default {
  name: 'SinginPage',
  data() {
    return {
      account: '',
      password: '',
    };
  },
  methods: {
    signinBtn: function () {
      this.account = this.account.trim();
      if (this.account == '') {
        global.showTips('账号不能为空');
        return;
      }
      if (this.password == '') {
        global.showTips('密码不能为空');
        return;
      }
      global.postData("user/v2/signin", {
        'account': this.account,
        'password': this.password,
      })
        .then(data => {
          if (data.code == 200) {
            global.userinfo = {
              'email': data.body.email,
              'telphone': data.body.telphone,
              'avatar': data.body.avatar,
              'nickname': data.body.nickname,
              'token': data.body.token,
            };
            localStorage.setItem("userinfo", JSON.stringify(global.userinfo));
            this.$router.push('/home');
          } else {
            global.showTips(data.msg);
          }
        });
    }
  },
  created() {
    global.sysncUserInfo();
    console.log(this.$route.params);
  },
}
</script>
<style scoped>
.page {
  margin-top: 8%;
}
</style>